import React, { useRef, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { ReactComponent as MenuIcon } from '../../../../public/shared/menu-icon-default.svg';
import { ReactComponent as EmbedIcon } from '../../../../public/icons/MenuIcons/embed.svg';
import { ReactComponent as ShareIcon } from '../../../../public/icons/MenuIcons/share.svg';
import { ReactComponent as NextArrowIcon } from '../../../../public/icons/MenuIcons/next_arrow.svg';
import { ReactComponent as AddToPlayListIcon } from '../../../../public/shared/add-icon.svg';
import { ReactComponent as ReportIcon } from '../../../../public/icons/MenuIcons/report.svg';
import { ReactComponent as RemoveIcon } from '../../../../public/icons/MenuIcons/remove.svg';
import { ReactComponent as QueueIcon } from '../../../../public/icons/MenuIcons/queue.svg';
import { ReactComponent as DistributeIcon } from "../../../../public/icons/MenuIcons/distributeIcon.svg";
import EmbedModal from '../../EmbedModal';
import SocialMediaSubmenu from '../../../App/shared/SocialMediaSubmenu';
import AddTrackToPlayistModal from '../../../App/shared/MediaTag/AudioTag/AddTrackToPlaylistModal';
import { useSelector } from 'react-redux';
import { ISource } from '../../../../@types/ISource';
import { ISoundtrack } from '../../../../@types/ISoundtrack';
import { IUser } from '../../../../@types/IUser';
import { isInQueue, isSelfId } from '../../../../api/helper';
import PrimoSubscriptionModal from "../../../App/shared/PrimoSubscriptionModal";
import {isDistroEnabled} from '../../../../helper/helper';
import {distributeAlbum} from "../../../../api/albums";
import { log_error } from "../../../../api";
import get from 'lodash/get';
import { isJSDocNonNullableType } from 'typescript';

interface IProps {
  sourceOwner: IUser;
  source: ISource;
  medium: ISoundtrack;
  onRemoveMedium?: (medium: ISoundtrack) => void;
  onReportMedium?: (medium: ISoundtrack) => void;
  onRemoveFromQueue?: (medium: ISoundtrack) => void;
  onAddToQueue?: (medium: ISoundtrack) => void;
}

function ToggleMenu(props: IProps) {
  const { current_user, queue } = useSelector(
    ({ current_user, queue }: any) => ({
      current_user,
      queue,
    })
  );
  let [loading, setLoading] = useState(false);

  const [distributeAlbumSuccess, setDistributeAlbumSuccess] = useState("");
  const [distributeAlbumError, setDistributeAlbumError] = useState("");
  const email = current_user && get(current_user,"email", null);
  const user_type = current_user && get(current_user,"user_type",null);
  const stopPropagation = (e: any) => e.stopPropagation();
  const target = useRef(null);
  const [show, setShow] = useState(false);
  const [subscribeModal, setSubscribeModal] = useState(false);

  const handleDistributeClick = async () => {
    if (current_user.is_subscribed_to_primo) {
      if (props.medium.distributed_on_eveara && props.medium.eveara_album_path) {
        window.open(props.medium.eveara_album_path);
      } else {
        setLoading(true);
        try {
          const { status, data } = await distributeAlbum(props.medium.id, 'single');
          if (status === 200) setDistributeAlbumSuccess(data.success);
        } catch (error) {
          setDistributeAlbumError(log_error(error));
          console.log(log_error(error));
        } finally {
          setLoading(false);
        }
      }
    } else {
      setSubscribeModal(true);
    }
  };

  const actions = [];
  if (isInQueue(props.medium) && props.onRemoveFromQueue)
    actions.push({
      key: "removeFromQueue",
      label: "Remove From Queue",
      icon: <QueueIcon />,
      method: () => {
        if (props.onRemoveFromQueue) props.onRemoveFromQueue(props.medium);
      },
    });
  else if (!isInQueue(props.medium) && props.onAddToQueue && queue?.queue?.length)
    actions.push({
      key: "addToQueue",
      label: "Add To Queue",
      icon: <QueueIcon />,
      method: () => {
        if (props.onAddToQueue) props.onAddToQueue(props.medium);
      },
    });

  if (isSelfId(props.sourceOwner.id) && props.onRemoveMedium)
    actions.push({
      key: 'removeMedium',
      label: 'Remove',
      icon: <RemoveIcon />,
      method: () => {
        if (props.onRemoveMedium) props.onRemoveMedium(props.medium);
      },
    });
  if (props.onReportMedium)
    actions.push({
      key: 'reportMedium',
      label: 'Report',
      icon: <ReportIcon />,
      method: () => {
        if (props.onReportMedium) props.onReportMedium(props.medium);
      },
    });

  return (
  <>
    {distributeAlbumSuccess && (
      <div
        className="alert alert-success"
        role="alert"
        dangerouslySetInnerHTML={{ __html: distributeAlbumSuccess }}
      />
    )}
     {distributeAlbumError && (
          <div
            className="alert alert-danger"
            role="alert"
            dangerouslySetInnerHTML={{
              __html: distributeAlbumError || distribution_decline_msg,
            }}
          />
        )}
    <Dropdown onClick={stopPropagation}>
      {/* @ts-ignore */}
      <Dropdown.Toggle as={MenuIcon} />
      <Dropdown.Menu>
        <div className="dropdown-item">
          <AddTrackToPlayistModal user={current_user} medium={props.medium}>
            <AddToPlayListIcon />
            <span className="ml-2">Add to playlist</span>
          </AddTrackToPlayistModal>
        </div>

        <Dropdown.Item
          className="d-flex"
          onMouseEnter={() => setShow(true)}
          onMouseLeave={() => setShow(false)}
          ref={target}
        >
          <ShareIcon />
          <span className="ml-2">Share</span>
          <NextArrowIcon height="12" width="12" className="ml-2 mt-2" />
          {/* @ts-ignore */}
          <SocialMediaSubmenu
            type={props.medium.type}
            object={props.medium}
            target={target}
            show={show}
          />
        </Dropdown.Item>

        <Dropdown.Item>
          <EmbedModal object={props.medium}>
            <EmbedIcon />
            <span className="ml-2">Embed Track</span>
          </EmbedModal>
        </Dropdown.Item>

        {isDistroEnabled(email, user_type) &&
          isSelfId(props.medium.user.id) && (
            <Dropdown.Item onClick={handleDistributeClick}>
              <DistributeIcon  />
              <span className="ml-2">Distribute</span>
            </Dropdown.Item>
          )}
        {subscribeModal && (
            <PrimoSubscriptionModal
              showModal={subscribeModal}
              setSubscribeModal={setSubscribeModal}
              albumId={props.medium.id}
              setDistributeAlbumSuccess={setDistributeAlbumSuccess}
              setDistributeAlbumError={setDistributeAlbumError}
            />
          )}

        {actions.map((action) => (
          <Dropdown.Item className="d-flex" onClick={action.method}>
            {action.icon}
            <span className="ml-2">{action.label}</span>
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
    </>
  );
}

export default ToggleMenu;
